import styled from "styled-components";
import {HomepageHeaderArenaSkeletonDefaultBox} from "./home-page-header-arena-skeleton.default.box";

export const HomepageHeaderArenaSkeletonCasino888Box = styled(HomepageHeaderArenaSkeletonDefaultBox)`
    top: 50%;
    left: 50%;
    max-width: 219px;
    max-height: 186px;
    transform: translate(-50%, -50%);
    &::before {
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        border-radius: 16px;
    }
`;